import type {IdentityVerificationSchema} from '../identityVerification';

export const getSetupFormData = (state: IdentityVerificationSchema) =>
  state.setupFormDate;
